import type {
  EntitySupplementTag,
  EntitySupplementTagUpdate,
  ResponseBaseGetOneResponseEntitySupplementTag,
} from "@classes-service-types/index.ts";
import { type UseMutationOptions, useMutation, useQueryClient } from "@tanstack/vue-query";
import type { Ref } from "vue";
import { unref } from "vue";
import entitySupplementService from "@/services/entitySupplement.js";
import { learningServiceRequest } from "@/services/utils.js";
import { getEntitySupplementQueryKey } from "./useGetSingleEntitySupplement.ts";

type UsePutEntitySupplementArgs = {
  id: Ref<string>;
  payload: EntitySupplementTagUpdate;
};

export const usePutEntitySupplement = (
  useMutationOptions?: UseMutationOptions<EntitySupplementTag, Error, UsePutEntitySupplementArgs>,
) => {
  const queryClient = useQueryClient();

  return useMutation<EntitySupplementTag, Error, UsePutEntitySupplementArgs>({
    mutationFn: async ({ id, payload }) => {
      const response = await learningServiceRequest<ResponseBaseGetOneResponseEntitySupplementTag>({
        method: "put",
        url: `/entity_supplement/${unref(id)}`,
        payload: payload,
        failureMessage: "Error updating Entity Supplement data",
      });
      return response?.data?.data?.items;
    },
    onSuccess: async (data, { id }) => {
      await queryClient.invalidateQueries({ queryKey: getEntitySupplementQueryKey(id) });
    },
    ...useMutationOptions,
  });
};
